import {Component, EventEmitter, forwardRef, Input, Optional, Output} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator} from "@angular/forms";
import {NbinputConfig, SystemAttachment,NbFieldType} from "./nbinput.entity";
import {NbinputUploadService} from "./nbinput-upload";

@Component({
  selector: 'nbinput-file',
  template: require('./nbinput-file.component.html'),
  styles: [require('./nbinput-file.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputFileComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NbinputFileComponent),
      multi: true,
    }
  ]
})

export class NbinputFileComponent implements ControlValueAccessor, Validator {
  @Input()
  token: string;
  upload: string;
  download: string;

  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};

  validate(c: AbstractControl): { [key: string]: any; } {
    this.data.forEach(e => {
      if (!e.completed || !e.success) {
        return {
          FilesOnUploading: {
            valid: false,
          },
        }
      }
    });
    return null;
  }
  registerOnValidatorChange?(fn: () => void): void {}
  writeValue(obj: SystemAttachment[]): void {
    if (obj && Array.isArray(obj)) {
      this.data = obj;
    }
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {this.onTouchedCallback = fn;}
  @Input()
  public disabled;
  onBlur() {
    this.onTouchedCallback();
  }

  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }
  @Input()
  public data: SystemAttachment[] = [];
  @Input()
  public readonly = false;

  @Input()
  public type:NbFieldType = NbFieldType.File;

  @Output()
  public onFileChange: EventEmitter<any> = new EventEmitter();
  submit() {
    const out = this.data.filter(e => e.completed && e.success);
    this.onFileChange.emit(out);
    this.onChangeCallback(out);
  }

  onChange(event) {
    for (let i = 0; i < event.target.files.length; i++){
      // event.target.data[i].callback = this.submit;
      let a = new SystemAttachment(event.target.files[i]);
      this.data.push(a);
      this.uploader.upload(event.target.files[i],this.upload)
        .subscribe(e=>{
          (<any>Object).assign(a,e);
          if (e.completed) {
            this.submit();
          }
        });
    }
  }

  delFile(img) {
    for (let i = 0;i < this.data.length;i++) {
      if (this.data[i] == img) {
        this.data.splice(i,1);
        this.submit();
        break;
      }
    }
  }

  constructor(
    private uploader: NbinputUploadService,
    @Optional() private config: NbinputConfig,
  ) {
    this.upload = config.uploadAPI;
    this.download = config.downloadAPI;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-file.component.ts